import { useMemo } from 'react'
import { useAppSelector } from 'universal-scripts'
import { haveItemsChanged } from 'src/utils/dashboardItemsUtils'

export const useDashboardHasChanges = () => {
  const { draft, original } = useAppSelector((state) => state.dashboard)
  return useMemo(() => {
    if (!original) {
      return !!draft.title?.trim() || (draft.items?.length ?? 0) > 0
    }
    if (draft.title !== original.title) return true
    if (draft.public !== original.public) return true
    if (haveItemsChanged(original.items, draft.items)) return true
    return false
  }, [draft, original])
}

export const useDashboardHasTitle = () => {
  return useAppSelector(
    (state) => (state.dashboard.draft.title ?? '').trim() !== ''
  )
}
